import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
} from "@mui/material";

/**
 * ConfirmationDialog renders a modal with title, message and confirm/cancel actions.
 * Props: open, onClose, onConfirm, title, message, confirmText, cancelText, confirmButtonColor, icon.
 */
export default function ConfirmationDialog(props: any) {
  const {
    open,
    onClose,
    onConfirm,
    title,
    message,
    confirmText,
    cancelText = "Cancel",
    confirmButtonColor = "primary",
    icon,
  } = props;
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      slotProps={{
        paper: {
          sx: {
            borderRadius: "10px",
            maxWidth: "500px",
          },
        },
      }}
    >
      {/* Centered icon above title */}
      {icon && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mt: 2,
          }}
        >
          {icon}
        </Box>
      )}
      <DialogTitle
        sx={{ textAlign: "center", color: "#1B2F3F", fontWeight: 600 }}
      >
        {title}
      </DialogTitle>
      <DialogContent>
        <p style={{ margin: 0, color: "#666", textAlign: "center" }}>
          {message}
        </p>
      </DialogContent>
      <DialogActions style={{ padding: "16px 24px" }}>
        <Button
          onClick={() => {
            onClose();
          }}
          variant="outlined"
          sx={{
            borderRadius: "30px",
            backgroundColor: "transparent",
            border: "1px solid #CFCEDA",
            color: "#403C6F",
            textTransform: "none",
            width: "187px",
            height: "42px",
            "&:hover": {
              backgroundColor: "rgba(207, 206, 218, 0.1)",
              border: "1px solid #CFCEDA",
            },
          }}
        >
          {cancelText}
        </Button>
        <Button
          onClick={() => {
            onConfirm();
          }}
          variant="contained"
          sx={{
            borderRadius: "30px",
            textTransform: "none",
            width: "187px",
            height: "42px",
            backgroundColor:
              confirmButtonColor === "error" ? "#F15B59" : undefined,
            "&:hover": {
              backgroundColor:
                confirmButtonColor === "error" ? "#d14b49" : undefined,
            },
          }}
          color={
            confirmButtonColor === "error" ? undefined : confirmButtonColor
          }
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
